import { ShieldCheck } from 'lucide-vue-next'
import type { App } from 'vue'

export * from './store'

export const createVerification = () => ({
  install: (app: App) => {
    const router = app.getRouter()

    // Both halves of one state machine (FR-A7–A11 and FR-A14), but only the queue is a screen of its own.
    router.addRoute('settings', {
      path: 'verification',
      name: 'settings-verification',
      meta: { head: { titleKey: 'verification.tab' } },
      component: () => import('./components/VerificationPanel.vue')
    })

    router.addRoute('admin', {
      path: 'verification',
      name: 'admin-verification-queue',
      meta: {
        head: { titleKey: 'verification.queueTitle' },
        nav: { icon: ShieldCheck, order: 0 },
        crumbs: [{ labelKey: 'nav.admin' }, { labelKey: 'verification.queueTitle' }]
      },
      component: () => import('./pages/VerificationQueuePage.vue')
    })
  }
})
